import classNames from 'classnames';
import { ImgHTMLAttributes } from 'react';

import ccBackImage from '../../assets/cc-mini-back.png';
import ccBack2xImage from '../../assets/cc-mini-back@2x.png';
import ccFrontImage from '../../assets/cc-mini-front.png';
import ccFront2xImage from '../../assets/cc-mini-front@2x.png';

const IMAGES = {
  cvvBack: {
    lowRs: ccBackImage,
    highRs: ccBack2xImage,
    dataZta: '',
  },
  cvvFront: {
    lowRs: ccFrontImage,
    highRs: ccFront2xImage,
    dataZta: '',
  },
};

export type ImageIconType = keyof typeof IMAGES;

interface IconProps extends ImgHTMLAttributes<HTMLImageElement> {
  type: ImageIconType;
  className?: string;
}

const ImageIcon: React.FC<IconProps> = ({ className, type, ...otherProps }) => {
  const image = IMAGES[type];
  return image ? (
    <img
      {...otherProps}
      src={image.lowRs}
      className={classNames(className)}
      alt={type}
      srcSet={`${image.lowRs} 1x, ${image.highRs} 2x`}
      data-zta={image.dataZta}
    />
  ) : null;
};

export default ImageIcon;
